<div class="small-container">
  <div class="row">

  <ng-container *ngIf="!pickupRequestCompleted">
    <div class="col-12 col-sm-12 pickup-form-wrap">
      <h2 class="title">{{'PICKUP_FORM.TITLE' | translate}}</h2>
      <p class="description">{{'PICKUP_FORM.DESCRIPTION' | translate}}</p>

      <form [formGroup]="pickupForm" (ngSubmit)="onSubmit()">
        <div class="form-group with-icon">
          <label for="address">{{'PICKUP_FORM.ADDRESS' | translate}} <span class="req">*</span></label>
          <i class="icon">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M10.0002 17.5V14.1667M10.0002 10.8333V7.5M10.0002 4.16667V2.5M8.3335 17.5H11.6668M6.66683 4.16667V7.5H15.8335L17.5002 5.83333L15.8335 4.16667H6.66683ZM11.6668 10.8333V14.1667H5.00016L3.3335 12.5L5.00016 10.8333H11.6668Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </i>
          <input id="address" type="text"
                 formControlName="address" (input)="onAddressSearch($event)"/>
          <span class="loader" *ngIf="loadingAddress"></span>
          <ul *ngIf="addressSuggestions.length" class="suggestions-list">
            <li *ngFor="let suggestion of addressSuggestions"
                (click)="selectAddress(suggestion);">
              {{ suggestion.displayName }}
            </li>
          </ul>
          <div *ngIf="pickupForm.get('address')?.touched && pickupForm.get('address')?.value">
            <p class="text-danger"
               *ngIf="pickupForm.get('address')?.errors?.['countryNotSupported']">
              {{'PICKUP_FORM.COUNTRY_NOT_SUPPORTED' | translate: { selectedCountry: unsupportedCountryName, supportedCountries: getAllowedCountriesDisplay() } }}
            </p>
            <p class="text-danger"
               *ngIf="!pickupForm.get('address')?.errors?.['countryNotSupported'] && !selectedAddress">
              {{'PICKUP_FORM.ADDRESS_ERROR' | translate}}
            </p>
          </div>
        </div>

        <div class="form-group bags-wrap mt-3">
          <label for="additionalNotes">{{'PICKUP_FORM.NUMBER_OF_BAGS' | translate}} <span class="req">*</span></label>
          <div class="input-group">
            <input id="bags" type="number" formControlName="bags" readonly [placeholder]="'PICKUP_FORM.NUMBER_OF_BAGS_PLACEHOLDER' | translate" />
            <div class="button-bags" (click)="decrementBags()" [ngClass]="{'inactive': pickupForm.get('bags')?.value < 1}">
              <i class="icon icon-minus"></i>
            </div>
            <div class="button-bags" (click)="incrementBags()" [ngClass]="{'inactive': pickupForm.get('bags')?.value > 9}">
              <i class="icon icon-plus"></i>
            </div>
          </div>
        </div>

        <div class="form-group with-icon mt-3">
          <label for="donateTo">{{'PICKUP_FORM.DONATE_TO' | translate}}</label>
          <i class="icon">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M8.75 9.16659H10.8333L9.58333 13.3333M12.5 3.33325L17.5 4.99992V9.16659H15V15.8333C15 16.0543 14.9122 16.2662 14.7559 16.4225C14.5996 16.5788 14.3877 16.6666 14.1667 16.6666H5.83333C5.61232 16.6666 5.40036 16.5788 5.24408 16.4225C5.0878 16.2662 5 16.0543 5 15.8333V9.16659H2.5V4.99992L7.5 3.33325C7.5 3.99629 7.76339 4.63218 8.23223 5.10102C8.70107 5.56986 9.33696 5.83325 10 5.83325C10.663 5.83325 11.2989 5.56986 11.7678 5.10102C12.2366 4.63218 12.5 3.99629 12.5 3.33325Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </i>
          <input id="donateTo" type="text" formControlName="donateTo" [attr.placeholder]="'PICKUP_FORM.DONATE_TO_PLACEHOLDER' | translate"
                 (input)="onDonateSearch($event)" />
          <span class="loader" *ngIf="loadingDonationTo"></span>
          <i class="icon icon-close" *ngIf="pickupForm.get('donateTo')?.value && !loadingDonationTo" (click)="clearDonateOption()"></i>
          <ul *ngIf="donateOptions.length" class="suggestions-list donate-to">
            <li *ngFor="let option of donateOptions" (click)="selectDonateOption(option); $event.stopPropagation()">
              <div class="team">
                <span class="avatar" [style]="option.avatar ? 'background-image: url(' + option.avatar + ')' : ''"></span>
                <p class="name">{{ option.name }}</p>
              </div>
            </li>
          </ul>
          <div *ngIf="(pickupForm.get('donateTo')?.touched && pickupForm.get('donateTo')?.value && !selectedDonateTo) || loadingDonationToError">
            <p class="text-danger" *ngIf="selectedDonateTo">{{'PICKUP_FORM.DONATE_TO_ERROR' | translate}}</p>
            <p class="text-danger" *ngIf="loadingDonationToError">{{'PICKUP_FORM.FORM_ERROR_SHORT' | translate}}</p>
          </div>
        </div>

        <div class="row">
          <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
            <div class="form-group with-icon mt-3 date-field">
              <label for="pickupDateFrom">{{'PICKUP_FORM.DATE_FROM' | translate}} <span class="req">*</span></label>
              <i class="icon">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M13.3335 2.5V5.83333M6.66683 2.5V5.83333M3.3335 9.16667H16.6668M3.3335 5.83333C3.3335 5.39131 3.50909 4.96738 3.82165 4.65482C4.13421 4.34226 4.55814 4.16667 5.00016 4.16667H15.0002C15.4422 4.16667 15.8661 4.34226 16.1787 4.65482C16.4912 4.96738 16.6668 5.39131 16.6668 5.83333V15.8333C16.6668 16.2754 16.4912 16.6993 16.1787 17.0118C15.8661 17.3244 15.4422 17.5 15.0002 17.5H5.00016C4.55814 17.5 4.13421 17.3244 3.82165 17.0118C3.50909 16.6993 3.3335 16.2754 3.3335 15.8333V5.83333ZM6.66683 12.5H8.3335V14.1667H6.66683V12.5Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </i>
              <input id="pickupDateFrom" type="text"
                     formControlName="pickupDateFrom"
                     autocomplete="off"
                     bsDatepicker
                     [minDate]="minDate"
                     [bsConfig]="{ containerClass: 'theme-dark-blue', dateInputFormat: 'DD-MM-YYYY', showWeekNumbers: false, adaptivePosition: true }"
                     readonly />
              <i class="icon icon-chevron-right"></i>
              <div *ngIf="pickupForm.get('pickupDateFrom')?.touched && pickupForm.get('pickupDateFrom')?.invalid">
                <small class="text-danger">{{'PICKUP_FORM.FIELD_REQUIRED' | translate}}</small>
              </div>
            </div>
          </div>

          <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
            <div class="form-group with-icon mt-3 date-field">
              <label for="pickupDateTo">{{'PICKUP_FORM.DATE_TO' | translate}} <span class="req">*</span></label>
              <i class="icon">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M13.3335 2.5V5.83333M6.66683 2.5V5.83333M3.3335 9.16667H16.6668M3.3335 5.83333C3.3335 5.39131 3.50909 4.96738 3.82165 4.65482C4.13421 4.34226 4.55814 4.16667 5.00016 4.16667H15.0002C15.4422 4.16667 15.8661 4.34226 16.1787 4.65482C16.4912 4.96738 16.6668 5.39131 16.6668 5.83333V15.8333C16.6668 16.2754 16.4912 16.6993 16.1787 17.0118C15.8661 17.3244 15.4422 17.5 15.0002 17.5H5.00016C4.55814 17.5 4.13421 17.3244 3.82165 17.0118C3.50909 16.6993 3.3335 16.2754 3.3335 15.8333V5.83333ZM6.66683 12.5H8.3335V14.1667H6.66683V12.5Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </i>
              <input id="pickupDateTo" type="text"
                     formControlName="pickupDateTo"
                     autocomplete="off"
                     bsDatepicker
                     [minDate]="pickupForm.get('pickupDateFrom')?.value || minDate"
                     [bsConfig]="{ containerClass: 'theme-dark-blue', dateInputFormat: 'DD-MM-YYYY', showWeekNumbers: false, adaptivePosition: true }"
                     readonly />
              <i class="icon icon-chevron-right"></i>
              <div *ngIf="pickupForm.get('pickupDateTo')?.touched && pickupForm.get('pickupDateTo')?.invalid">
                <small class="text-danger">{{'PICKUP_FORM.FIELD_REQUIRED' | translate}}</small>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
            <div class="form-group with-icon mt-3 time-field">
              <label for="pickupTimeFrom">{{'PICKUP_FORM.TIME_FROM' | translate}} <span class="req">*</span></label>
              <i class="icon">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12.9167 10H10V5.83333M2.5 10C2.5 10.9849 2.69399 11.9602 3.0709 12.8701C3.44781 13.7801 4.00026 14.6069 4.6967 15.3033C5.39314 15.9997 6.21993 16.5522 7.12987 16.9291C8.03982 17.306 9.01509 17.5 10 17.5C10.9849 17.5 11.9602 17.306 12.8701 16.9291C13.7801 16.5522 14.6069 15.9997 15.3033 15.3033C15.9997 14.6069 16.5522 13.7801 16.9291 12.8701C17.306 11.9602 17.5 10.9849 17.5 10C17.5 9.01509 17.306 8.03982 16.9291 7.12987C16.5522 6.21993 15.9997 5.39314 15.3033 4.6967C14.6069 4.00026 13.7801 3.44781 12.8701 3.0709C11.9602 2.69399 10.9849 2.5 10 2.5C9.01509 2.5 8.03982 2.69399 7.12987 3.0709C6.21993 3.44781 5.39314 4.00026 4.6967 4.6967C4.00026 5.39314 3.44781 6.21993 3.0709 7.12987C2.69399 8.03982 2.5 9.01509 2.5 10Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </i>
              <input id="pickupTimeFrom" type="text"
                     [value]="pickupForm.get('pickupTimeFrom')?.value | date: 'HH:mm'"
                     readonly
                     [popover]="timeFromTemplate"
                     [outsideClick]="true"
                     container="body"
                     placement="bottom" />
              <i class="icon icon-chevron-right"></i>
              <ng-template #timeFromTemplate>
                <timepicker formControlName="pickupTimeFrom" [showMeridian]="false" [min]="isTodaySelected ? minTime : undefined"></timepicker>
              </ng-template>
              <div *ngIf="pickupForm.get('pickupTimeFrom')?.touched && pickupForm.get('pickupTimeFrom')?.invalid">
                <small class="text-danger">{{'PICKUP_FORM.FIELD_REQUIRED' | translate}}</small>
              </div>
            </div>
          </div>

          <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
            <div class="form-group with-icon mt-3 time-field">
              <label for="pickupTimeTo">{{'PICKUP_FORM.TIME_TO' | translate}} <span class="req">*</span></label>
              <i class="icon">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12.9167 10H10V5.83333M2.5 10C2.5 10.9849 2.69399 11.9602 3.0709 12.8701C3.44781 13.7801 4.00026 14.6069 4.6967 15.3033C5.39314 15.9997 6.21993 16.5522 7.12987 16.9291C8.03982 17.306 9.01509 17.5 10 17.5C10.9849 17.5 11.9602 17.306 12.8701 16.9291C13.7801 16.5522 14.6069 15.9997 15.3033 15.3033C15.9997 14.6069 16.5522 13.7801 16.9291 12.8701C17.306 11.9602 17.5 10.9849 17.5 10C17.5 9.01509 17.306 8.03982 16.9291 7.12987C16.5522 6.21993 15.9997 5.39314 15.3033 4.6967C14.6069 4.00026 13.7801 3.44781 12.8701 3.0709C11.9602 2.69399 10.9849 2.5 10 2.5C9.01509 2.5 8.03982 2.69399 7.12987 3.0709C6.21993 3.44781 5.39314 4.00026 4.6967 4.6967C4.00026 5.39314 3.44781 6.21993 3.0709 7.12987C2.69399 8.03982 2.5 9.01509 2.5 10Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </i>
              <input id="pickupTimeTo" type="text"
                     [value]="pickupForm.get('pickupTimeTo')?.value | date: 'HH:mm'"
                     readonly
                     [popover]="timeToTemplate"
                     [outsideClick]="true"
                     container="body"
                     placement="bottom" />
              <i class="icon icon-chevron-right"></i>
              <ng-template #timeToTemplate>
                <timepicker formControlName="pickupTimeTo" [showMeridian]="false"></timepicker>
              </ng-template>
              <div *ngIf="pickupForm.hasError('timeRangeInvalid') && pickupForm.touched">
                <p class="text-danger">{{'PICKUP_FORM.DATE_ERROR' | translate}}</p>
              </div>
              <div *ngIf="pickupForm.hasError('minimumDurationNotMet') && pickupForm.touched">
                <p class="text-danger">{{'PICKUP_FORM.MINIMUM_DURATION_ERROR' | translate}}</p>
              </div>
            </div>
          </div>
        </div>


        <div class="form-group mt-3">
          <label for="additionalNotes">{{'PICKUP_FORM.ADDITIONAL_NOTES' | translate}}</label>
          <textarea id="additionalNotes" formControlName="additionalNotes"></textarea>
        </div>

        <div *ngIf="error" class="general-error">
          <p class="text-danger">{{'PICKUP_FORM.FORM_ERROR' | translate}}</p>
        </div>

        <button class="btn btn-primary with-loader mt-4"
                [disabled]="pickupForm.invalid
                || (pickupForm.get('donateTo')?.touched && pickupForm.get('donateTo')?.value && !selectedDonateTo)
                || (pickupForm.get('address')?.touched && pickupForm.get('address')?.value && !selectedAddress)">
          {{'PICKUP_FORM.BUTTON' | translate}} <span class="loader" *ngIf="loading"></span>
        </button>
      </form>
    </div>
  </ng-container>


  <ng-container *ngIf="pickupRequestCompleted">
    <div class="col-12 col-sm-12">
      <div class="pickup-request-confirmed-wrap">
        <div class="title-wrap">
          <i class="icon">
            <svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M41.6666 86.5708C38.04 85.7482 34.5569 84.3873 31.3333 82.5333M58.3332 13.4291C66.6172 15.321 74.0134 19.9695 79.3109 26.6133C84.6084 33.2571 87.4933 41.5026 87.4933 49.9999C87.4933 58.4972 84.6084 66.7427 79.3109 73.3866C74.0134 80.0304 66.6172 84.6788 58.3332 86.5708M19.079 71.2208C16.8061 67.9186 15.0798 64.2719 13.9665 60.4208M13.0166 43.7499C13.6833 39.7916 14.9666 36.0416 16.7666 32.6041L17.4708 31.3332M28.7789 19.0791C32.6775 16.3953 37.0511 14.4779 41.6664 13.4291M37.4998 49.9999L45.8332 58.3333L62.4998 41.6666" stroke="#2667FF" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </i>
          <h2>{{'PICKUP_CONFIRMED.TITLE' | translate}}</h2>
          <p>{{'PICKUP_CONFIRMED.THANKS_MESSAGE' | translate}}</p>
        </div>

        <div class="store-buttons-wrap">
          <h3 [innerHTML]="'PICKUP_CONFIRMED.DOWNLOAD_TEXT' | translate"></h3>

          <a [href]="storeLinks.GIPANT.appStore" class="store-btn apple" target="_blank"></a>
          <a [href]="storeLinks.GIPANT.googlePlay" class="store-btn android" target="_blank"></a>
        </div>

        <div class="pickup-request-data mt-4">
          <div>
            <p class="key">{{'PICKUP_CONFIRMED.NAME' | translate}}:</p><p class="value" *ngIf="userData">{{userData.user.profile.name}} {{userData.user.profile.last_name}}</p>
          </div>
          <div>
            <p class="key">{{'PICKUP_CONFIRMED.PHONE' | translate}}:</p><p class="value" *ngIf="userData">{{userData.user.profile.phone_number}}</p>
          </div>
          <div>
            <p class="key">{{'PICKUP_CONFIRMED.ADDRESS' | translate}}:</p><p class="value">{{pickupRequestCompletedData?.address_line}} {{pickupRequestCompletedData?.address_line_2 ? ', ' + pickupRequestCompletedData?.address_line_2 : ''}}, {{pickupRequestCompletedData?.postal_code}}, {{pickupRequestCompletedData?.state}}, {{pickupRequestCompletedData?.city}}, {{pickupRequestCompletedData?.country}}</p>
          </div>
          <div>
            <p class="key">{{'PICKUP_CONFIRMED.BAGS' | translate}}:</p><p class="value">{{pickupRequestCompletedData?.bags_number}}</p>
          </div>
          <div *ngIf="pickupRequestCompletedData?.target_team && pickupRequestCompletedData?.target_team?.name">
            <p class="key">{{'PICKUP_CONFIRMED.TARGET' | translate}}:</p><p class="value">{{pickupRequestCompletedData?.target_team?.name}}</p>
          </div>
          <div>
            <p class="key">{{'PICKUP_CONFIRMED.DATE' | translate}}:</p><p class="value">{{pickupRequestCompletedData?.from_date | date: 'd MMM HH:mm'}} - {{pickupRequestCompletedData?.to_date | date: 'd MMM HH:mm'}}</p>
          </div>
          <div *ngIf="pickupRequestCompletedData?.additional_notes">
            <p class="key">{{'PICKUP_CONFIRMED.NOTES' | translate}}:</p>
          </div>
          <div class="additional-notes" *ngIf="pickupRequestCompletedData?.additional_notes">
            <p class="value">{{pickupRequestCompletedData?.additional_notes}}</p>
          </div>
        </div>

        <div class="button-wrap mt-5">
          <button class="btn btn-primary" (click)="backToHome()">{{'PICKUP_CONFIRMED.BUTTON' | translate}}</button>
        </div>
      </div>
    </div>
  </ng-container>

  </div>
</div>



